import { render, staticRenderFns } from "./PvpStatRadar.vue?vue&type=template&id=83bed540&scoped=true"
import script from "./PvpStatRadar.vue?vue&type=script&lang=js"
export * from "./PvpStatRadar.vue?vue&type=script&lang=js"
import style0 from "./PvpStatRadar.vue?vue&type=style&index=0&id=83bed540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83bed540",
  null
  
)

export default component.exports